import React from 'react';
import { useLocation } from "react-router-dom";

const NotFound: React.FC = () => {
  const pathname = useLocation().pathname;
  const isFacility = pathname.split("/").includes("facility");

  return (
    <React.Fragment>
      <header id="main-header" className="main-header main-header--page main-header--user">
        <div className="main-header__inner">
          <a href={ isFacility ? "/facility/top" : "/customer/top" } className="main-header__logo">
            <picture>
              <source srcSet={`${process.env.PUBLIC_URL}/img/webp/common/logo-white-sp.webp`} media="(max-width:834px)" type="image/webp" />
              <source srcSet={`${process.env.PUBLIC_URL}/img/common/logo-white-sp.png`} media="(max-width:834px)"/>
              <source srcSet={`${process.env.PUBLIC_URL}/img/webp/common/logo-white.webp`} type="image/webp" />
              <img src="img/common/logo-white.png" alt="SEED" />
            </picture>
          </a>
        </div>
      </header>
      <main className="wrapper">
        <section>
          <div className="inner mtpc-100 mtsp-50">
            <div className="c-al--c">
              <h2 className="c-ttl__01 mbsp-13">404 Not Found</h2>
              <p className="c-txt__01 contact-box__txt">お探しのページが見つかりません。<br />URLに誤りがあるか、お探しのページは移動もしくは削除された可能性があります。</p>
              <a href={ isFacility ? "/facility/top" : "/customer/top" } className="c-btn__01 c-btn__01--white">TOPページに戻る</a>
            </div>
          </div>
        </section>
      </main>
      <footer id="main-footer" className="main-footer main-footer--page">
        <div className="inner">
          <p className="main-footer__copyright">Copyright &copy; SEED Co., Ltd. All Rights Reserved.</p>
        </div>
      </footer>
    </React.Fragment>
  );
}

export default NotFound;
